<template>
  <b-modal
    :key="rerenderKey"
    content-class="mymodalContent"
    modal-class="mymodal"
    id="print"
    size="xl"
    centered
    scrollable
    hide-header
    hide-footer
    @show="onShow"
    @hide="onHide"
  >
    <div class="modal-div">
      <div class="printParameters">
        <h2 v-html="$t('components.popinPrint.title')"></h2>
        <span v-html="$t('components.popinPrint.text')"></span>
        <span v-if="!compagnyCompleted" class="warning-msg">
          <alert-icon title="" />
          <p
            class="my-p"
            v-html="$t('components.popinPrint.msgNothingtoPrint')"
          ></p>
        </span>
        <!-- zone de choix -->
        <div class="options-container" v-if="compagnyCompleted">
          <b-form-checkbox
            :disabled="!synthesisAccessible"
            class="synthesis"
            v-model="selectedSections.synthesis"
            >{{
              $t("components.popinPrint.options.synthesis")
            }}</b-form-checkbox
          >

          <b-form-checkbox
            class="compagny"
            v-model="selectedSections.compagny"
            >{{ $t("components.popinPrint.options.compagny") }}</b-form-checkbox
          >

          <div class="themes">
            <b-form-radio-group
              v-model="selectedSections.themes"
              :options="printedThemesOptions"
              class="myoption"
              stacked
              @input="buildThemesList()"
            ></b-form-radio-group>

            <info-message
              :text="$t('components.popinPrint.printLandscapeTip')"
              class="printLandscapeTip"
              :style="{
                visibility:
                  selectedSections.themes != 'none' ? 'visible' : 'hidden'
              }"
            />
          </div>
        </div>

        <div class="popin-actions">
          <b-button class="popin-btn-cancel" @click="closePopin()">
            <cancel-icon title="" />{{ $t("components.popinPrint.btnCancel") }}
          </b-button>
          <b-button
            v-if="compagnyCompleted"
            class="refonte_btn-primary popin-btn-confirm"
            :disabled="
              !selectedSections.synthesis &&
                !selectedSections.compagny &&
                selectedSections.themes == 'none'
            "
            @click="print()"
          >
            <printer-icon title="" />{{ $t("components.popinPrint.btnPrint") }}
          </b-button>
        </div>
      </div>

      <!-- zone d'impression -->
      <div class="container-to-print">
        <div class="content-to-print printed">
          <!-- Intro -->
          <page-intro 
            :showMenu="false" 
            :view="currentView" 
            v-on:changeview="$emit('changeview',$event)"
          ></page-intro>

          <!-- synthèse -->
          <div
            v-if="selectedSections.synthesis"
            class="printedSection synthesis"
          >
            <!--
            <h2>
              {{ $t("components.popinPrint.sections.synthesis.title") }}
            </h2>
            -->

            <synthesis :printMode="true"></synthesis>
          </div>

          <!-- formulaire entreprise -->
          <div v-if="selectedSections.compagny" class="printedSection compagny">
            <h2>
              {{ $t("components.popinPrint.sections.compagny.title") }}
            </h2>
            <compagny-form :printMode="true"></compagny-form>
          </div>

          <!-- contenu de chaque thème -->
          <div v-if="themesToPrint.length > 0" class="printedSection themes">
            <h2 v-if="selectedSections.themes == 'current'">
              {{ $t("components.popinPrint.sections.themes.currentTitle") }}
            </h2>
            <h2 v-if="selectedSections.themes == 'completed'">
              {{ $t("components.popinPrint.sections.themes.completedTitle") }}
            </h2>
            <h2 v-if="selectedSections.themes == 'notCompleted'">
              {{
                $t("components.popinPrint.sections.themes.notCompletedTitle")
              }}
            </h2>
            <h2 v-if="selectedSections.themes == 'all'">
              {{ $t("components.popinPrint.sections.themes.allTitle") }}
            </h2>

            <div
              v-for="theme in themesToPrint"
              :key="theme.abbreviation"
              class="themeSection"
            >
              <h4 class="myOrangeTitle">
                [{{ theme.abbreviation }}] - {{ theme.title }}
              </h4>

              <div class="block-observations">
                <h5>{{ $t("views.themeView.title1") }}</h5>
                <info-message
                  v-if="theme.subThemes.length == 0"
                  :text="$t('components.popinPrint.msgSubthemesEmpty')"
                />
                <sub-theme-section
                  v-for="(subtheme, index) in theme.subThemes"
                  :key="subtheme.ref"
                  :themeAbbr="theme.abbreviation"
                  :subTheme="subtheme"
                  :id="index"
                  :edit="false"
                  :printMode="true"
                ></sub-theme-section>
              </div>

              <div class="block-objectificationElements">
                <h5>{{ $t("views.themeView.title2") }}</h5>
                <div class="themeElementContainer">
                  <levels-section
                    v-if="theme.objectificationElements.length"
                    :themeAbbr="theme.abbreviation"
                    :contentList="theme.objectificationElements"
                    data-type="OBJECTIFICATIONS"
                    :printMode="true"
                  ></levels-section>
                  <info-message
                    v-else
                    :text="$t('components.popinPrint.msgObjectificationEmpty')"
                  />
                </div>
              </div>

              <div class="block-analysis">
                <h5>{{ $t("views.themeView.title3") }}</h5>

                <div class="themeElementContainer">
                  <h5
                    class="subtitle"
                    v-html="$t('views.themeView.title3_subtitle1')"
                  ></h5>
                  <span
                    class="printedField textarea bordered"
                    v-html="theme.analysis"
                  ></span>
                </div>

                <global-rating :theme="theme" mode="print"></global-rating>
              </div>

              <div class="block-progressProposals">
                <h5>{{ $t("views.themeView.title4") }}</h5>

                <progress-proposals
                  :edit="false"
                  view="theme"
                  :theme="theme"
                  :printMode="true"
                ></progress-proposals>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import PageIntro from "../PageIntro";
import CompagnyForm from "../compagny/CompagnyForm";
import SubThemeSection from "../theme/SubThemeSection";
import LevelsSection from "../theme/LevelsSection";
import GlobalRating from "../theme/GlobalRating";
import ProgressProposals from "../theme/ProgressProposals";
import Synthesis from "../synthesis/Synthesis";
import InfoMessage from "../global/InfoMessage.vue";
import AlertIcon from "vue-material-design-icons/Alert.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import PrinterIcon from "vue-material-design-icons/Printer.vue";
//import printJS from "print-js";

export default {
  name: "PopinPrint",
  components: {
    PageIntro,
    CompagnyForm,
    SubThemeSection,
    LevelsSection,
    GlobalRating,
    ProgressProposals,
    Synthesis,
    AlertIcon,
    CancelIcon,
    PrinterIcon,
    InfoMessage
  },
  props: {
    currentView: String,
    currentTheme: Object
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    },
    themes: function() {
      return this.gpsst.themes;
    },
    compagnyCompleted: function() {
      return this.$store.state.appState.compagnyCompleted;
    },
    synthesisAccessible: function() {
      // on regarde si l'accès à la synthèse est possible
      // FIXME à factoriser
      var themes = this.gpsst.themes;
      if (this.$store.state.appState.compagnyCompleted) {
        for (let i = 0; i < themes.length; i++) {
          if (
            themes[i].status == "complete" ||
            themes[i].status == "incomplete"
          ) {
            return true;
          }
        }
        return false;
      }
      return false;
    }
  },
  data: function() {
    return {
      selectedSections: {
        synthesis: false,
        compagny: false,
        themes: "none"
      },
      themesToPrint: [],
      output: null,
      rerenderKey: 0,
      isVisible: false,
      sortedThemes: null,
      printedThemesOptions : [],
      printStarted: false
    };
  },
  destroyed: function() {
    this.removePrintListeners();
  },
  methods: {
    /**
     * Callback appelée juste avant l'affichage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onShow: function(bvModalEvt) { //eslint-disable-line no-unused-vars
      this.sortThemes();
      this.buildPrintedThemesOptions();
      this.generateDefaultSelection();
      this.buildThemesList();
      this.addPrintListeners();
      this.isVisible = true;
    },
    /**
     * Callback appelée juste avant le masquage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onHide: function(bvModalEvt) { //eslint-disable-line no-unused-vars
      this.removePrintListeners();
      this.afterPrint(); // par sécurité au cas où l'événement n'aurait pas été émis par certains navigateurs
      this.isVisible = false;
    },
    /**
     * Ferme la modale.
     */
    closePopin: function() {
      this.$bvModal.hide("print");
    },
    /**
     * Ajoute les listeners de modification du DOM juste avant et après l'impression.
     */
    addPrintListeners: function() {
      // console.log("addPrintListeners");
      if (window.matchMedia) {
        var mediaQueryList = window.matchMedia("print");
        mediaQueryList.addListener(this.mqlPrintListener);
      }

      window.addEventListener("beforeprint", this.beforePrint);
      window.addEventListener("afterprint", this.afterPrint);
    },
    /**
     * Supprime les listeners de modification du DOM juste avant et après l'impression.
     */
    removePrintListeners: function() {
      // console.log("removePrintListeners");
      if (window.matchMedia) {
        var mediaQueryList = window.matchMedia("print");
        mediaQueryList.removeListener(this.mqlPrintListener);
      }

      window.removeEventListener("beforeprint", this.beforePrint);
      window.removeEventListener("afterprint", this.afterPrint);
    },
    /**
     * Listener de détection avant/après impression spécifique aux navigateurs qui gèrent matchMedia.
     */
    mqlPrintListener: function(mql) {
      if (mql.matches) {
        this.beforePrint();
      } else {
        this.afterPrint();
      }
    },
    /**
     * Préparation du DOM juste avant l'impression (peut être appelé plusieurs fois sans risque car blindage par ajout de la classe 'popinPrinting' sur le body).
     */
    beforePrint: function() {
      if (!this.isVisible) {
        return;
      }

      this.printStarted = true;

      // console.log("beforePrint 1");
      var body = $("body"); //eslint-disable-line no-undef
      if (body.hasClass("popinPrinting")) {
        return;
      }

      // console.log("beforePrint 2");
      body.addClass("popinPrinting");
      $(".content-to-print").appendTo(body); //eslint-disable-line no-undef
      body
        .children()
        .not(".content-to-print")
        .addClass("dontPrint");
    },
    /**
     * Préparation du DOM juste après l'impression (peut être appelé plusieurs fois sans risque car blindage par ajout de la classe 'popinPrinting' sur le body).
     */
    afterPrint: function() {
      if (!this.isVisible) {
        return;
      }

      // console.log("afterPrint 1");
      var body = $("body"); //eslint-disable-line no-undef
      if (!body.hasClass("popinPrinting")) {
        return;
      }

      // console.log("afterPrint 2");
      $(".content-to-print").appendTo($(".container-to-print")); //eslint-disable-line no-undef
      body.children().removeClass("dontPrint");
      body.removeClass("popinPrinting");

      // Fermeture auto de la popin
      this.closePopin();
    },

    /**
     * Déclenche l'impression par le navigateur.
     */
    print: function() {
      var that = this;

      this.printStarted = false;
      setTimeout(function() {
        try {
          document.execCommand("print", false, null);
        } catch (e) {
          window.print();
        }
      }, 250);

      // Si la demande d'impression n'a pas eu lieu peu après, on retente sans le defer
      setTimeout(function() {
        if (!that.printStarted) {
          window.print();
        }
      }, 500);

    },
    /**
     * Génère les options d'impression par défaut à l'affichage de la popin.
     */
    generateDefaultSelection: function() {
      this.selectedSections = {
        synthesis: false,
        compagny: true,
        themes: "none"
      };

      // Sélection par défaut
      switch (this.currentView) {
        case "home":
          this.selectedSections = {
            synthesis: this.synthesisAccessible,
            compagny: true,
            themes: "completed"
          };

          break;

        case "compagny":
          this.selectedSections = {
            synthesis: false,
            compagny: true,
            themes: "none"
          };
          break;

        case "themesList":
          this.selectedSections = {
            synthesis: false,
            compagny: false,
            themes: "all"
          };
          break;

        case "theme":
          this.selectedSections = {
            synthesis: false,
            compagny: false,
            themes: "current"
          };
          break;

        case "synthesis":
          this.selectedSections = {
            synthesis: true,
            compagny: false,
            themes: "none"
          };
          break;
      }

      // Détermination des thèmes à imprimer
      this.buildThemesList();
    },
    /**
     * Tri les thèmes
     */
    sortThemes: function() {
      //TODO à factoriser avec celui de Analysis.vue

      var completedThemes = [];
      var notCompletedThemes = [];
      var themes = this.$store.state.gpsstModule.gpsst.themes;

      for (let h = 0; h < themes.length; h++) {
        var theme = themes[h];
        if (theme.status == "complete") {
          completedThemes.push(theme);
        } else {
          notCompletedThemes.push(theme);
        }
      }

      // on trie les thèmes ayant une cotation par cotation croissante et à cotation égale, par ordre alphabétique
      completedThemes.sort(function(a, b) {
        if (a.globalRating.rating != b.globalRating.rating) {
          return a.globalRating.rating - b.globalRating.rating;
        }
        return b.title.localeCompare(a.title);
      });

      // on trie les autres thèmes par ordre alphabétique
      notCompletedThemes.sort(function(a, b) {
        return b.title.localeCompare(a.title);
      });

      this.sortedThemes = {
        completedThemes: completedThemes,
        notCompletedThemes: notCompletedThemes,
        allThemes: completedThemes.concat(notCompletedThemes)
      };
    },
    buildPrintedThemesOptions : function() {
      var options = [
        {
          value: "none",
          text: this.$i18n.t("components.popinPrint.options.themes.none")
        },
        {
          value: "current",
          text: this.$i18n.t(
            "components.popinPrint.options.themes.current",
            this.currentTheme || {}
          )
        },
        {
          value: "completed",
          text: this.$i18n.t("components.popinPrint.options.themes.completed", [
            this.sortedThemes.completedThemes.length
          ])
        },
        {
          value: "notCompleted",
          text: this.$i18n.t(
            "components.popinPrint.options.themes.notCompleted",
            [this.sortedThemes.notCompletedThemes.length]
          )
        },
        {
          value: "all",
          text: this.$i18n.t("components.popinPrint.options.themes.all", [
            this.sortedThemes.allThemes.length
          ])
        }
      ];

      // On retire la seconde option si on n'est pas sur la vue "thème"
      if (this.currentView != "theme") {
        options.splice(1, 1);
      }

      this.printedThemesOptions = options;
    },
    /**
     * Construit la liste des thèmes à imprimer
     */
    buildThemesList: function() {
      this.themesToPrint = [];

      switch (this.selectedSections.themes) {
        case "current":
          this.themesToPrint = [this.currentTheme];
          break;

        case "completed":
          this.themesToPrint = this.sortedThemes.completedThemes;
          break;

        case "notCompleted":
          this.themesToPrint = this.sortedThemes.notCompletedThemes;
          break;

        case "all":
          this.themesToPrint = this.sortedThemes.allThemes;
          break;

        case "none":
        default:
          break;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"

.printParameters
  @media print
    display: none

  .options-container
    display: flex
    justify-content: space-between
    width: 100%
    margin: 1em 0

    > .synthesis
      width: 30%

    > .compagny
      width: 30%

    > .themes
      width: 40%

    //.myoption
    //  display: inline-block    

  .printLandscapeTip
    margin: 1em 0
    color: $tip-color
    text-align: left
    

.content-to-print
  border-top: 2px solid $gray-3
  margin:2em 0 0 0
  padding: 1em 0
  display: none

  @media print
    display: block
    width: 100%
    border: none
    margin: 0
    padding: 0


  .intro-container
    @media print
      margin: 0 0 2em 0

  .block-observations
    .sub-theme
      break-inside: avoid
      page-break-inside: avoid

      &:first-child
        break-inside: auto

  .block-objectificationElements, .block-analysis, .block-progressProposals
    margin-top: 1em
    break-inside: avoid
    page-break-inside: avoid

  h1, h2, h3, h4, h5, h6
    break-after: avoid
    page-break-after: avoid

  .printedSection
    border-bottom: 2px dotted $gray-3    
    margin: 1em 0
    padding: 1em 0

    @media print
      border: none
      page-break-after: always
      margin: 0
      padding: 0

    &:last-child
      page-break-after: auto
      border-bottom: none

    > h2
      font-family: pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
      color: $orange-color
      font-weight: bold
      margin: 0 0 0.25em 0
      font-size: 2.3em

    .themeSection
      border-bottom: 1px dotted $gray-3

      @media print
        border: none
        page-break-after: always
        margin: 0
        padding: 0

      &:last-child
        page-break-after: auto
        border-bottom: none

      h4.myOrangeTitle
        margin-top: 0

      h5
        font-family: pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
        font-size: 1.6em
        color: #ea7420
        margin: 1em 0 0.25em 0

        &.subtitle
          font-size: 1.3em
          color: $gray-3
          margin: 0.5em 0 0.25em 0
          padding: 0

  

</style>
